<div style="float: left; margin-bottom: 2rem; margin-top: 1rem">
  <button mat-raised-button color="primary" (click)="openCreateNationalDialog()">{{ 'Create Nationals Games' | translate }}</button>
</div>

<table mat-table [dataSource]="nationalGames" class="mat-elevation-z8">
  <ng-container matColumnDef="homeTeam">
    <th mat-header-cell *matHeaderCellDef> {{ 'Home Team' | translate }}</th>
    <td mat-cell *matCellDef="let game"> {{game.homeTeam}} </td>
  </ng-container>

  <ng-container matColumnDef="awayTeam">
    <th mat-header-cell *matHeaderCellDef> {{ 'Away Team' | translate }}</th>
    <td mat-cell *matCellDef="let game"> {{game.awayTeam}} </td>
  </ng-container>

  <ng-container matColumnDef="leagueType">
    <th mat-header-cell *matHeaderCellDef> {{ 'League Type' | translate }}</th>
    <td mat-cell *matCellDef="let game"> {{game.leagueType}} </td>
  </ng-container>

  <ng-container matColumnDef="gameDate">
    <th mat-header-cell *matHeaderCellDef> {{ 'Game Date' | translate }}</th>
    <td mat-cell *matCellDef="let game">
      {{ game.gameDate | date: 'dd MMM yyyy - HH:mm' }}
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef> {{ 'Status' | translate }}</th>
    <td mat-cell *matCellDef="let game"> {{game.status}} </td>
  </ng-container>

  <ng-container matColumnDef="edit-result">
    <th mat-header-cell *matHeaderCellDef> {{ 'Ndrysho rezultatin' | translate }} </th>
    <td mat-cell *matCellDef="let game">
      <a  (click)="openResultDialog(game)" style="cursor: pointer; color: deepskyblue; font-size: 18px; margin-left: 1rem">
        <i class="fa fa-edit"></i>
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="open">
    <th mat-header-cell *matHeaderCellDef> {{ 'Ndrysho te dhenat' | translate }} </th>
    <td mat-cell *matCellDef="let game">
      <a  (click)="openEditNationalDialog(game)" style="cursor: pointer; color: deepskyblue; font-size: 18px; margin-left: 1rem">
        <i class="fa fa-edit"></i>
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="remove">
    <th mat-header-cell *matHeaderCellDef> {{ 'Remove' | translate }} </th>
    <td mat-cell *matCellDef="let game">
      <a (click)="deleteGame(game.id)" style="cursor: pointer; color: red; font-size: 18px; margin-left: 1rem;">
        <i class="fa fa-remove"></i>
      </a>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<mat-paginator [pageSize]="pageSize" [length]="totalItems"></mat-paginator>
